import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import routeConstant from "../lib/constants/routeConstant";

const ProtectedRoutes = () => {
    // Handle User SignedIn
    const { isSignedIn } = useSelector(state => state.user)

    return (
        // Check if user is signed in, render the child routes (Outlet) else navigate to Default Page
        isSignedIn ? <Outlet /> : <Navigate to={routeConstant.LOGIN_PAGE} />
    );
};

export default ProtectedRoutes;
